import { render, staticRenderFns } from "./priceTable.vue?vue&type=template&id=1e863b80&"
import script from "./priceTable.vue?vue&type=script&lang=js&"
export * from "./priceTable.vue?vue&type=script&lang=js&"
import style0 from "./priceTable.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports